import axios from 'axios';
import * as object from './object';

export * from 'axios';

export function AxiosStatusCode(err: unknown): number | undefined {
    if (object.IsObject(err) && object.IsObject(err['response']) && typeof err['response']['status'] === 'number') {
        return err['response']['status'];
    }

    // successful response
    if (object.IsObject(err) && typeof err['status'] === 'number') {
        return err['status'];
    }
}

declare interface myWindow extends Window {
    readonly apiRoot: string;
    readonly axiosDefaultHeaders: Record<string, string>;
}
// use "self" because we might be in a worker, where "window" is not defined
declare const self: myWindow;

const Client = axios.create({
    baseURL: self.apiRoot,
    withCredentials: true,
    paramsSerializer: { indexes: null },
    headers: self.axiosDefaultHeaders,
});

export function SetBaseURL(url: string) {
    Client.defaults.baseURL = url;
}

export default Client;